import { tabsClasses } from '../Tabs';
import colors from '../theme/colors';
import palette from '../theme/palette';

const variants = [
  {
    props: { indicatorColor: 'grey' },
    style: {
      [`& .${tabsClasses.indicator}`]: {
        backgroundColor: colors.solidGray[700],
      },
    },
  },
  {
    props: { indicatorColor: 'internal' },
    style: {
      [`& .${tabsClasses.indicator}`]: {
        backgroundColor: palette.internal.main,
      },
    },
  },
  {
    props: { isSubMenu: true, orientation: 'vertical' },
    style: {
      [`& .${tabsClasses.indicator}`]: {
        width: '4px',
      },
    },
  },
  {
    props: { withoutIndicator: true },
    style: {
      [`& .${tabsClasses.indicator}`]: {
        display: 'none',
      },
    },
  },
  {
    props: { orientation: 'horizontal' },
    style: {
      '& .MuiTabs-scroller': {
        overflowY: 'hidden',
      },
    },
  },
];

export default variants;
